import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import sha256 from 'crypto-js/sha256';
import { Subscription } from 'rxjs';
import { ImageCropperDialogComponent } from 'src/app/components/shared-components/image-cropper-dialog/image-cropper-dialog.component';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { UserService } from 'src/app/services/user-service/user.service';
import { ValidationImageService } from 'src/app/services/validation-images-service/validation-image.service';
import { StaffsHelpbuttonService } from '../../../services/helpbutton-services/staffs-helpbutton-service/staffs-helpbutton.service';
import { UserStorageService } from '../../../services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-helpbutton-new-staff-creation-card',
  templateUrl: './helpbutton-new-staff-creation-card.component.html',
  styleUrls: ['./helpbutton-new-staff-creation-card.component.scss']
})
export class HelpbuttonNewStaffCreationCardComponent implements OnInit, OnDestroy {

  @ViewChild('uploadInput', { static: false }) uploadInput: ElementRef;
  addNewStaffSubscription: Subscription;
  staff;
  imageBASE64;
  centerList;
  state: boolean;
  showButton: boolean;
  showSpinner;
  basicDataForm = new FormGroup({
    staffEmail: new FormControl(null, [Validators.required, Validators.email]),
    staffPassword: new FormControl(null, Validators.required),
    staffFirstname: new FormControl(null, Validators.required),
    staffLastname: new FormControl(null, Validators.required),
    selectedCenter: new FormControl(null, Validators.required),
    staffActive: new FormControl(true)
  });

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private userStorageService: UserStorageService,
    private staffsService: StaffsHelpbuttonService,
    private snackbarService: SnackBarService,
    private validationImageService: ValidationImageService,
    private spinnerService: SpinnerService,
    private userService: UserService,
    public dialog: MatDialog) {
    this.showButton = true;
  }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
    this.basicDataForm.patchValue({
      selectedCenter: this.getSelectedCenterInternalId()
    });
  }

  public addNewStaff() {
      this.showButton = false;
      this.spinnerService.show('staff-new-spinner');
      const validation = this.validateForm();
      if (validation === true) {
        this.addNewStaffSubscription = this.staffsService.addNewStaff(this.imageBASE64, this.basicDataForm.get('staffActive').value, this.basicDataForm.get('staffEmail').value, this.basicDataForm.get('staffFirstname').value, this.basicDataForm.get('staffLastname').value, sha256(this.basicDataForm.get('staffPassword').value).toString().toUpperCase(), this.getSelectedCenterInternalId()).subscribe(
          (res) => {
            this.showButton = true;
            this.spinnerService.hide('staff-new-spinner');
            this.userService.refreshUser();
            this.router.navigate(['../../staffs'], { relativeTo: this.activatedRoute });
          },
          (error) => {
            this.showButton = true;
            this.spinnerService.hide('staff-new-spinner');
            this.snackbarService.open(error['error']['message'], 'error');
          }
        );
    } else {
      this.showButton = true;
      this.spinnerService.hide('staff-new-spinner');
      this.snackbarService.open(validation, 'error');
    }
  }

  public cancelStaff() {
    this.router.navigate(['../../staffs'], { relativeTo: this.activatedRoute });
  }

  private validateForm() {
    if (!this.imageBASE64) {
      return 'helpbutton-page.snackbar messages.image staff error';
    } else if (!this.basicDataForm.get('staffEmail').valid) {
      return 'helpbutton-page.snackbar messages.email staff error';
    } else if (!this.basicDataForm.get('staffPassword').valid) {
      return 'helpbutton-page.snackbar messages.password staff error';
    } else if (!this.basicDataForm.get('staffFirstname').valid) {
      return 'helpbutton-page.snackbar messages.firstname staff error';
    } else if (!this.basicDataForm.get('staffLastname').valid) {
      return 'helpbutton-page.snackbar messages.lastname staff error';
    } else if (!this.basicDataForm.get('selectedCenter').valid) {
      return 'helpbutton-page.snackbar messages.selected center staff error';
    } else {
      return true;
    }
  }

  public getSelectedCenterInternalId() {
    if (this.centerList.length === 1) {
      return this.centerList[0].InternalId;
    } else {
      if (this.basicDataForm.get('selectedCenter').value) {
        return this.basicDataForm.get('selectedCenter').value.InternalId;
      } else {
        return null;
      }
    }
  }

  public uploadPhotoClicker() {
    this.uploadInput.nativeElement.value = null;
    this.uploadInput.nativeElement.click();
  }

  public uploadAsset(event) {
    const file = event.target.files[0];
    const img = new Image();
    this.validationImageService.toBase64(file).subscribe(
      (base64) => {
        this.imageBASE64 = base64;
        const dialogRef = this.dialog.open(ImageCropperDialogComponent, {
          data: { image: this.imageBASE64, width: 250, height: 250 }
        });
        dialogRef.afterClosed().subscribe(action => { this.imageBASE64 = action; });
      },
      (error) => {
        this.snackbarService.open(error, 'error');
      }
    );
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  ngOnDestroy() {
    if (this.addNewStaffSubscription) { this.addNewStaffSubscription.unsubscribe(); }
  }

}
